const menu_data = [
  {
    id: 1,
    title: 'Home',
    link: '/',
    
  },
  
  {
    id: 2,
    hasDropdown: true,
    title: 'Features',
   
    submenus: [
      { title: 'network Membership Management', link: '/network' },
      { title: 'Event Website & Registration', link: '/event' },
      { title: 'One2One Meeting Scheduling', link: '/one2One' },
      { title: 'Event Management', link: '/eventManagement' },
     
    ]
  },
  {
    id: 3,
    title: 'Solutions',
    link: '/Solutions',
  },
  {
    id: 4,
    hasDropdown: true,
    title: 'Resources',
    
    submenus: [
      { title: 'Price', link: '/Price' },
      { title: 'Support', link: '/Support' },
      { title: 'About Us', link: '/About_Us' },
      { title: 'Contact Us', link: '/Contact_Us' },
    ]
  },

]

export default menu_data;
